import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useThree } from '@react-three/fiber';
import React, { memo, useEffect } from 'react';
import { Color, DoubleSide, LineBasicMaterial, LineSegments, SphereGeometry } from 'three';
import { COLORS } from '../../../../utils';
import { sphereToQuads } from './dummy360-utils';
const Dummy360Content = ({ radius }) => {
    const { scene } = useThree();
    useEffect(() => {
        const g = new SphereGeometry(radius, 60, 40);
        sphereToQuads(g);
        const m = new LineBasicMaterial();
        m.color = new Color(COLORS.aether);
        const o = new LineSegments(g, m);
        scene.add(o);
        return () => { scene.remove(o); };
    }, [radius, scene]);
    return (_jsxs("mesh", { children: [_jsx("sphereGeometry", { args: [radius, 60, 40] }), _jsx("meshBasicMaterial", { polygonOffset: true, polygonOffsetFactor: 10, color: COLORS.star, side: DoubleSide })] }));
};
export default memo(Dummy360Content);
